




















































































/** @format */

import { Component, Mixins, Watch } from 'vue-property-decorator';
import TableMixin from '@root/common/mixins/table';

import TableWidthMixin from '@root/common/mixins/table-width';
import PlateInput from '../../../components/plate-input/index.vue';
import moment from 'moment';
import { queryCardPlateRecordList } from '@/api/fixed-car-management';
import ParkingLotSearch from '../../../components/parking-lot-search/index.vue';
import DistributionTrack from '@/components/distribution-track/index.vue';
@Component({
  name: 'ChangeRecord',
  components: {
    ParkingLotSearch,
    PlateInput,
    DistributionTrack
  }
})
// @Component
export default class ChangeRecord extends Mixins(TableMixin, TableWidthMixin) {
  tableData: any[] = []; // 表数据

  private filterParam: any = {
    parkId: [],
    plateHead: '',
    plateTail: '',
    spaceCode: '',
    testName: 'userName',
    operateTimeStart: '',
    operateTimeEnd: '',
    codeVal: ''
  };
  clearPlate: boolean = false;
  clear({ defaultParkIdList }) {
    this.clearPlate = true;
    this.filterParam = {
      parkId: defaultParkIdList,
      plateHead: '',
      plateTail: '',
      spaceCode: '',
      testName: 'userName',
      operateTimeStart: '',
      operateTimeEnd: '',
      codeVal: ''
    };
    this.search();
  }
  tableLoading: boolean = false;

  async created() {
    this.fetchTableData();
  }

  /**
   * 点击搜索按钮
   */
  private search() {
    this.current = 1;
    this.fetchTableData();
  }

  /**
   * 获取列表数据
   */
  public async fetchTableData() {
    try {
      if (this.tableLoading) return;
      this.tableLoading = true;
      const {
        parkId,
        plateHead,
        plateTail,
        spaceCode,
        testName,
        operateTimeStart,
        operateTimeEnd,
        codeVal
      } = this.filterParam;
      if (plateTail && plateHead === '') {
        return this.$message.error('请先选择省份再进行查询');
      }
      const { status, msg, code, data } = await queryCardPlateRecordList({
        parkId: '' + parkId,
        plateHead,
        plateTail,
        spaceCode,
        userName: testName === 'userName' ? codeVal : '',
        roomNumber: testName === 'roomNumber' ? codeVal : '',
        operateTimeStart,
        operateTimeEnd,
        currPage: this.current,
        pageSize: this.pageSize
      });
      if (data) {
        const { pageSize = 0, currPage = 0, totalPage, totalNum = 0, datas = [] } = data;
        this.total = Number(totalNum);
        if (datas.length > 0) {
          this.tableData = Object.freeze(datas);
        } else {
          this.tableData = [];
        }
      }
    } catch (error) {
      console.log(error);
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
      console.log('queryCardPlateRecordList  接口调用错误', error);
    } finally {
      this.tableLoading = false;
    }
  }

  private moment = moment;

  private disabledDate(current: any) {
    return current && current >= moment().endOf('day');
  }

  /**
   *  时间
   */

  private onTimeChange(date: any, dateString: any) {
    let [operateTimeStart, operateTimeEnd] = dateString;
    this.filterParam.operateTimeStart = operateTimeStart;
    this.filterParam.operateTimeEnd = operateTimeEnd;
  }
  get defaultTime() {
    if (this.filterParam.operateTimeStart && this.filterParam.operateTimeEnd) {
      return [
        this.moment(this.filterParam.operateTimeStart, 'YYYY-MM-DD HH:mm:ss'),
        this.moment(this.filterParam.operateTimeEnd, 'YYYY-MM-DD HH:mm:ss')
      ];
    } else if (this.filterParam.operateTimeStart) {
      return [this.moment(this.filterParam.operateTimeStart, 'YYYY-MM-DD HH:mm:ss')];
    } else {
      return [];
    }
  }
  set defaultTime(val: any) {}

  /**
   * 车牌号
   * @param plateHead
   * @param plateTail
   */
  private plateChange([plateHead, plateTail]: any) {
    this.filterParam.plateHead = plateHead;
    this.filterParam.plateTail = plateTail;
  }

  // 表字段说明
  get tableColums() {
    return [
      {
        title: '序号',
        width: 70,
        customRender: (text: any, record: any, index: number) => `${(this.current - 1) * this.pageSize + index + 1}`
      },
      {
        title: '车场名称',
        dataIndex: 'parkName',
        width: 180,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      // {
      //   title: '卡号',
      //   dataIndex: 'cardNo',
      //   width: 140,
      // },
      {
        title: '车位编号',
        dataIndex: 'spaceCode',
        width: 170,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '车位用途',
        dataIndex: 'useType',
        width: 140
      },
      {
        title: '车主姓名',
        dataIndex: 'userName',
        width: 170,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '房号',
        dataIndex: 'roomNumber',
        width: 130,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '原车牌号',
        dataIndex: 'plateBefore',
        width: 170,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '变更车牌号',
        dataIndex: 'plateAfter',
        width: 170,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '操作渠道',
        dataIndex: 'source',
        width: 140
      },
      {
        title: '操作人',
        dataIndex: 'operater',
        width: 100,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '操作时间',
        dataIndex: 'operateTime',
        width: 200
      },
      {
        title: '下发状态',
        dataIndex: 'sendResult',
        width: 140,
        scopedSlots: { customRender: 'sendResult' }
      }
    ];
  }
  trendData: any = {};
  trendVisible: boolean = false;
  //显示下发轨迹
  showTrend(record: any) {
    this.trendData = record;
    this.trendData.businessKey = record.id;
    this.trendData.businessType = '02';
    this.trendVisible = true;
  }
  //
  closeIt() {
    this.trendVisible = false;
  }
  //
  redistribute() {
    this.closeIt();
    this.fetchTableData();
  }
}
